<div class="full-height layout-column discussions">

  <!-- Query Row-->
  <div class="layout-row layout-align-start-center padding-10 gap-5">
    <chat-user-input class="flex"
                     (onSelect)="onUserSelect.emit($event)">

    </chat-user-input>
    <button type="button" class="btn btn-outline-primary border-none" (click)="onClose.emit()">&#10006;</button>
  </div>
  <div *ngIf="conversations?.length" class="flex layout-column overflow-auto">

    <chat-conversations-list-item *ngFor="let conversation of (conversations | chatConversationSortPipe: 'dateUpdated'); trackBy:identify"
                                  [conversation]="conversation"
                                  (onSelect)="onSelect($event)"
                                  (onMessageAdded)="onMessageAdded($event)">

    </chat-conversations-list-item>

  </div>
  <div *ngIf="!conversations"
       class="flex layout-column layout-align-center-center fade-element-in-only">
    <div class="spinner-border text-primary" role="status"></div>
  </div>
  <div *ngIf="!!conversations && !conversations?.length"
       class="flex layout-column layout-align-center-center fade-element-in-only">
    <img class="empty-state" src="assets/images/empty_state/empty_state_user.png"/>
    <span class="br-body-2 color-gray-102">{{'No Conversations Found' | translate}}</span>
  </div>
</div>
